import { Injectable } from '@angular/core';
import { AddressService } from "../address.service";
import { FormControlBase } from "../../dynamic-form/form-control-base";
import { PasswordControl } from "../../dynamic-form/password-control";
import { TextboxControl } from "../../dynamic-form/textbox-control";
import { DropdownControl } from "../../dynamic-form/dropdown-control";
import { CheckboxControl } from "../../dynamic-form/checkbox-control";
import { LoyaltySiteManagementComponent } from './loyalty-site-management.component';
import { LoyaltySiteManagementService } from './loyalty-site-management.service';


@Injectable()
export class LoyaltySiteManagementFieldService {

    constructor(
        private loyaltymanagementComponent: LoyaltySiteManagementService,
        private addressService: AddressService
    ) { }

    public getFields(): Array<FormControlBase<any>> {
        let fields = new Array<FormControlBase<any>>();

        let siteIdField = new TextboxControl();
        siteIdField.key = 'siteId';
        siteIdField.label = 'Location ID';
        siteIdField.placeHolder = 'Enter location ID'
        siteIdField.order = 2;
        siteIdField.required = true;
        siteIdField.preventKeys = '\\w';
        fields.push(siteIdField);

        let currentId = new TextboxControl();
        currentId.key = 'CurrentId';
        currentId.label = 'Current ID';
        currentId.placeHolder = 'Enter Current ID'
        currentId.order = 4;
        currentId.preventKeys = '\\w';
        fields.push(currentId);

        let siteNameField = new TextboxControl();
        siteNameField.key = 'SiteName';
        siteNameField.label = 'Location Name';
        siteNameField.placeHolder = 'Enter location name';
        siteNameField.order = 3;
        siteNameField.required = true;
        siteNameField.preventKeys = '\\w';
        fields.push(siteNameField);

        let locationGroupField = new DropdownControl();
        locationGroupField.key = 'LocationGroupID';
        locationGroupField.label = 'Location Group';
        locationGroupField.order = 5;
        fields.push(locationGroupField);

        let inlandField = new DropdownControl();
        inlandField.key = 'LocationType';
        inlandField.label = 'Location Type';
        inlandField.order = 5;
        inlandField.options = this.addressService.getLocationTypes();
        inlandField.options.forEach(x => x.key = x.value);
        fields.push(inlandField);

        let posUnit = new DropdownControl();
        posUnit.key = 'POS';
        posUnit.label = 'POS';
        posUnit.order = 5;
        posUnit.options = this.addressService.getPosUnits();
        posUnit.options.forEach(x => x.key = x.value);
        fields.push(posUnit);

        let address1Field = new TextboxControl();
        address1Field.key = 'address1';
        address1Field.label = 'Address';
        address1Field.placeHolder = 'Enter address';
        address1Field.order = 6;
        fields.push(address1Field);

        let address2Field = new TextboxControl();
        address2Field.key = 'address2';
        address2Field.label = '';
        address2Field.placeHolder = 'Enter address';
        address2Field.order = 7;
        fields.push(address2Field);

        let suburbField = new TextboxControl();
        suburbField.key = 'suburb';
        suburbField.label = 'Suburb';
        suburbField.placeHolder = 'Enter suburb';
        suburbField.order = 7;
        suburbField.preventKeys = '\\w';
        fields.push(suburbField);

        let cityField = new TextboxControl();
        cityField.key = 'city';
        cityField.label = 'City';
        cityField.placeHolder = 'Enter city'
        cityField.order = 8;
        cityField.preventKeys = '\\w';
        fields.push(cityField);

        let postalCodeField = new TextboxControl();
        postalCodeField.key = 'postalCode';
        postalCodeField.label = 'Postal Code';
        postalCodeField.placeHolder = 'Enter postal code';
        postalCodeField.order = 7;
        postalCodeField.preventKeys = '\\d';
        fields.push(postalCodeField);

        let provinceField = new DropdownControl();
        provinceField.key = 'provinceID'
        provinceField.label = 'Province';
        provinceField.order = 10;

        fields.push(provinceField);

        let countryField = new DropdownControl();
        countryField.key = 'country';
        countryField.label = 'Country';
        countryField.order = 9;
        countryField.options = this.addressService.getCountries();
        countryField.options.forEach(x => x.key = x.value);
        fields.push(countryField);

        let mobileNumberField = new TextboxControl();
        mobileNumberField.key = 'mobileNumber';
        mobileNumberField.label = 'Mobile Number';
        mobileNumberField.placeHolder = 'Enter mobile number';
        mobileNumberField.validNumberOnly = true;
        mobileNumberField.order = 11;
        mobileNumberField.preventKeys = '\\d';
        fields.push(mobileNumberField);

        let emailField = new TextboxControl();
        emailField.key = 'email';
        emailField.label = 'Email';
        emailField.placeHolder = 'Enter email';
        emailField.validEmail = true;
        emailField.order = 12;
        fields.push(emailField);

        let managerField = new TextboxControl();
        managerField.key = 'manager';
        managerField.label = 'Manager Name';
        managerField.placeHolder = 'Enter manager name';
        managerField.order = 13;
        managerField.preventKeys = '[a-zA-Z]';
        fields.push(managerField);

        let statusField = new CheckboxControl();
        statusField.key = 'status';
        statusField.label = 'Disabled';
        statusField.order = 14;
        fields.push(statusField);

        let tradingHoursField = new TextboxControl();
        tradingHoursField.key = 'TradingHours';
        tradingHoursField.label = 'Trading Hours';
        tradingHoursField.order = 15;
        fields.push(tradingHoursField);

        let latitudeField = new TextboxControl();
        latitudeField.key = 'latitude';
        latitudeField.label = 'Latitude';
        latitudeField.type = 'number';
        latitudeField.order = 15;
        fields.push(latitudeField);

        let longitudeField = new TextboxControl();
        longitudeField.key = 'longitude';
        longitudeField.label = 'Longitude';
        longitudeField.type = 'number';
        longitudeField.order = 16;
        fields.push(longitudeField);

        let userNameField = new TextboxControl();
        userNameField.key = 'userName';
        userNameField.label = 'Username';
        userNameField.placeHolder = 'Enter username';
        userNameField.order = 17;
        fields.push(userNameField);

        let passwordField = new PasswordControl();
        passwordField.key = 'password';
        passwordField.label = 'Password';
        passwordField.placeHolder = 'Enter password';
        passwordField.order = 18;
        fields.push(passwordField);

        let confirmPasswordField = new PasswordControl();
        confirmPasswordField.key = 'confirmPassword';
        confirmPasswordField.label = 'Confirm Password';
        confirmPasswordField.placeHolder = 'Enter confirm password';
        confirmPasswordField.order = 19;
        fields.push(confirmPasswordField);

        return fields.sort((a, b) => a.order - b.order);

    }

    
}


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/views/admin/loyalty-site/loyalty-site-management-field.service.ts